import React from "react"
import { graphql } from "gatsby"
import { useTabbedContainer } from "contexts/components/TabbedContainerContext"
import { SingleService } from "components/service-comparison/SingleService"
import { TextAndImageContentBlock } from "components/content-blocks/TextAndImageContentBlock"
import type { TabElements } from "./tabbed-content-block-types"

export const TabbedContent = () => {
  const { activeItem } = useTabbedContainer<TabElements>()

  const activeItemContentBlock = activeItem?.content_block
  const activeItemService = activeItem?.service

  if (activeItem.hasOwnProperty("service") && activeItemService !== null) {
    const { flag, icon, name, ...activeItemServicesWithOmittedProps } =
      activeItemService

    return <SingleService {...activeItemServicesWithOmittedProps} />
  }

  if (
    !activeItemContentBlock ||
    (activeItemContentBlock && Object.keys(activeItemContentBlock).length === 0)
  )
    return null

  const {
    // alternate_background_color,
    // content_block_type,
    // eyebrow_text,
    // sub_heading,
    // svg_icon,
    buttons,
    // heading,
    image,
    text,
  } = activeItemContentBlock

  return (
    <TextAndImageContentBlock
      buttons={buttons}
      content_block_type="default"
      eyebrow_text={null}
      hasBlockPadding={false}
      hasContainerClassName={false}
      heading={null}
      image={image}
      alternateBlocksCount={0}
      text={text?.data.text ?? null}
    />
  )
}

export const strapiContentQuery = graphql`
  fragment StrapiTabbedContentFragment on STRAPI__COMPONENT_CONTENT_BLOCK_CONTENT_BLOCK {
    alternate_background_color
    content_block_type
    eyebrow_text
    heading
    id
    style_lists_as_grid
    sub_heading
    svg_icon
    buttons {
      ...StrapiButtonFragment
    }
    image {
      alternativeText
      height
      name
      url
      width
    }
    text {
      data {
        text
      }
    }
  }
`

export const strapiServiceQuery = graphql`
  fragment StrapiTabbedServiceFragment on STRAPI__COMPONENT_CONTENT_BLOCK_SERVICE {
    anchor_reference
    button_text
    custom_anchor_reference
    flag
    id
    initial_fee
    migrated_associated_page
    name
    price
    price_term
    pricing_disclaimer
    starting_footage
    associated_page {
      slug
    }
    icon {
      # alternativeText
      height
      name
      url
      width
    }
    images {
      # alternativeText
      height
      name
      url
      width
    }
    pests_covered {
      data {
        pests_covered
      }
    }
    service_features {
      data {
        service_features
      }
    }
  }
`
